module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.change_name_visible) ? _c('div', {
    staticClass: "name_popup"
  }, [_c('div', {
    staticClass: "bg",
    on: {
      "click": _vm.hideChangeName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pop_up"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('p', [_vm._v("Введите ваше имя")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.hideChangeName
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 47.971 47.971"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.228 23.986L47.092 5.122a2.998 2.998 0 0 0 0-4.242 2.998 2.998 0 0 0-4.242 0L23.986 19.744 5.121.88a2.998 2.998 0 0 0-4.242 0 2.998 2.998 0 0 0 0 4.242l18.865 18.864L.879 42.85a2.998 2.998 0 1 0 4.242 4.241l18.865-18.864L42.85 47.091c.586.586 1.354.879 2.121.879s1.535-.293 2.121-.879a2.998 2.998 0 0 0 0-4.242L28.228 23.986z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('label', [_c('p', {
    staticClass: "field_name"
  }, [_vm._v("Имя")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userNames.name),
      expression: "userNames.name"
    }],
    attrs: {
      "name": "usrFirstName",
      "type": "text",
      "data-vv-validate-on": "none"
    },
    domProps: {
      "value": (_vm.userNames.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userNames, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('usrFirstName')),
      expression: "errors.has('usrFirstName')"
    }],
    staticClass: "field_err"
  }, [_vm._v("Необходимо ввести имя")])]), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "field_name"
  }, [_vm._v("Фамилия")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userNames.surname),
      expression: "userNames.surname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "usrLastName",
      "data-vv-validate-on": "none"
    },
    domProps: {
      "value": (_vm.userNames.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userNames, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('usrLastName')),
      expression: "errors.has('usrLastName')"
    }],
    staticClass: "field_err"
  }, [_vm._v("Необходимо ввести фамилию")])]), _vm._v(" "), _c('div', {
    staticClass: "save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveName($event)
      }
    }
  }, [_vm._v("Сохранить")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361b2b3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/change-name.vue
// module id = 294
// module chunks = 1